import { useEffect } from "react";

import { Identify } from "@amplitude/analytics-browser";

import type { AuthenticationStore } from "../../domain/authentication/AuthenticationStore";

import { driverAppAmplitudeInstance } from "./amplitudeInstances";

export function useUserIdentificationEffect(authenticationStore: AuthenticationStore) {
    const { userJWT, isDriver, isDriversCompany, isCompanyDriver } = authenticationStore;

    const userId = userJWT?.userId;
    useEffect(() => {
        // We cannot identify a user without an ID, so we wait for it.
        if (!userId) {
            return;
        }

        const identifyObj = new Identify()
            .set("is-driver", isDriver)
            .set("is-company-driver", isCompanyDriver)
            .set("is-drivers-company", isDriversCompany);

        // Identify user on driver app instance (for driver/assistant events)
        driverAppAmplitudeInstance.setUserId(userId);
        driverAppAmplitudeInstance.identify(identifyObj);
    }, [userId, isDriver, isDriversCompany, isCompanyDriver]);
}
